import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {WebsiteCourseCampusComponent} from './website-course-campus.component'
import {SharedModule} from '../shared/shared.module'
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap'
import {NgxJsonLdModule} from 'ngx-json-ld'
import {RichsnipetService} from 'dmmp-services'
import {CarouselModule} from 'ngx-owl-carousel-o'
@NgModule({
  declarations: [WebsiteCourseCampusComponent],
  imports: [
    CommonModule,
    SharedModule,
    NgbNavModule,
    NgxJsonLdModule,
    CarouselModule,
  ],
  exports: [
    WebsiteCourseCampusComponent
  ],
  providers: [RichsnipetService],
})
export class WebsiteCourseCampusModule {
}
